<template>
  <div class="h-full">
    <div class="flex h-full justify-end items-center">
      <vs-dropdown style="margin-left: 5px; cursor: pointer;" vs-custom-content vs-trigger-click>
        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>
        <vs-dropdown-menu style="min-width: 100px;">
          <vs-dropdown-item @click="goMarkList(params.data)"
          >Mark Entry</vs-dropdown-item>
           <vs-dropdown-item @click="goGradeBook(params.data)"
          >Result</vs-dropdown-item>
          <vs-dropdown-item @click="previewGradebookSidebar(params.data)"
          >Preview</vs-dropdown-item>
          <vs-dropdown-item @click="studentReportShare(params.data)"
          >Share to Students</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>    
</template>

<script>

import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'

export default {
  name: 'CellRendererAction',
  data () {
    return {
    }
  },
  mixins: [PermissionMiddleware],
  mounted () {
      this.getModulePermission('Grade')
  },
  methods: {
    async goMarkList(editObject){
       this.params.colDef.cellRendererParams.goMarkList(editObject)
    },
    goGradeBook(editObject){
       this.params.colDef.cellRendererParams.goGradeBook(editObject)
    },
    previewGradebookSidebar(editObject){
        this.params.colDef.cellRendererParams.previewGradebookSidebar(editObject)
    }, 
    studentReportShare(editObject){
        this.params.colDef.cellRendererParams.studentReportShare(editObject)
    }
  }
}
</script>